// @flow
import * as React from "react";
import {observer} from "mobx-react";
import {reisy, use} from "reisy";

import type {Direction, Position} from "./utils.js";
import Link from "../components/link.js";
import * as Icons from "../components/icons.js";

const styles = reisy`
@namespace Arrows;

Size: 24px;

Arrow {
	position: fixed;
	z-index: 10;
	top: 0; bottom: 0;
	margin: auto 0.5em auto 0;
	width: $Size;
	height: $Size;
	padding: 8px 8px 8px calc(0.5em + 8px);
	transition: all $Consts.Transition;
	cursor: pointer;
	overflow: hidden;
	box-sizing: content-box;
	background-color: rgba(64, 64, 64, 0.2);
	svg {
		width: 100%;
		height: 100%;
	}
	&:hover {
		background-color: rgba(64, 64, 64, 0.5);
	}

	@media print {
		display: none;
	}
}
ArrowLeft {
	@extends Arrow;
	left: 0;
}
ArrowRight {
	@extends Arrow;
	right: 0;
	margin: auto 0 auto 0.5em;
	padding: 8px calc(0.5em + 8px) 8px 8px;
}

hideArrow {
	opacity: 0;
	visibility: hidden;
}
`;

type ArrowProps = {
	direction: Direction;
	onClick: () => void;
	position: Position;
	makeLink?: (position: number) => string;
};

const Arrow = ({direction, onClick, position: _position, makeLink}: ArrowProps) => {
	const position = _position.target + (direction === "start" ? -1 : 1);
	return (
		<Link
			{...use(
				direction === "start" ? styles.ArrowLeft : styles.ArrowRight,
				(position < 0 || position > _position.max) && styles.hideArrow
			)}
			to={makeLink && makeLink(position)}
			onClick={onClick}
			rel={direction === "start" ? 'prev' : 'next'}>
			{React.createElement(direction === "start" ? Icons.ArrowLeft : Icons.ArrowRight)}
		</Link>
	);
};

export default observer(Arrow);



// WEBPACK FOOTER //
// ./lib/scroller/arrow.js